import * as React from "react";
import { observer } from "mobx-react-lite";
import { MultiStepItem } from "src/components/MultiStepTask/MultiStepItem";
import {
  lastStep,
  nextStep,
  prevStep,
} from "src/components/MultiStepTask/utils";
import { MultiStepEntsTable } from "src/components/MultiStepTask/utils/MultiStepEntsTable";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { Spin } from "antd";
import { t } from "i18next";
import { MultiStepTask } from "src/components/MultiStepTask";
import { Mc2PointsSelect } from "../../Mc2PointsSelect";
import { Mc2CopyFromStore } from "./Mc2CopyFromStore";

/*
Постановка задачи на копирование ИЗ
http://wiki.d4r.int/pages/viewpage.action?pageId=514854062
п 3.1
1. Нажимает "Копировать ИЗ"
2. Выбирает источник копирования (Модель) → Далее 
3. Выбирает MC для копирования → Далее 

хотя на макете всё несколько сложнее, но считаем правильным постановку в жире
*/

interface PropsMc2CopyFrom {
  store: Mc2CopyFromStore;
}

export const Mc2CopyFrom: React.FC<PropsMc2CopyFrom> = observer(({ store }) => {
  const { store1, store2 } = store;
  const steps: MultiStepItem[] = [
    {
      title: "Модель",
      description: "Выберите экземпляр-источник для копирования",
      next: nextStep(store.firstDisabled),
      drawContent: () =>
        store1 ? (
          <MultiStepEntsTable>
            <EntityFiltersTable store={store1} />,
          </MultiStepEntsTable>
        ) : (
          <Spin />
        ),
    },
    {
      title: "MC",
      description: "Выберите экземпляры МС, которые будут скопированы",
      onActive(fromPrevStep) {
        if (!fromPrevStep) store.initStep2();
      },
      prev: prevStep(),
      next: nextStep(store.secondDisabled),
      drawContent: () =>
        store2 ? <Mc2PointsSelect store={store2} /> : <Spin />,
    },
    lastStep(t("Copying"), store.copyInfo, async () => {
      await store.copy();
    }),
  ];
  return (
    <MultiStepTask
      title={t("Copy from")}
      taskStore={store.taskStore}
      steps={steps}
    />
  );
});
